/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var FileFormatHtmlIcon20Solid = forwardRef('FileFormatHtmlIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M11.573 2a2 2 0 0 1 1.415.586l3.426 3.426a2 2 0 0 1 .54.988H3V5a3 3 0 0 1 3-3h5.573Z" }),
        React.createElement("path", { d: "M3 14v1a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3v-1H3Z" }),
        React.createElement("path", { d: "M3.94 8H5v5H3.94v-2.028H2.06V13H1V8h1.06v2.015h1.88V8Z" }),
        React.createElement("path", { d: "M9.46 8H5.563v.979h1.402V13h1.082V8.979H9.46V8Z" }),
        React.createElement("path", { d: "M14.203 8H16v5h-1V8.93L13.546 13h-1.061L11 8.937V13h-1V8h1.86l1.163 3.5 1.18-3.5Z" }),
        React.createElement("path", { d: "M18.071 8H17v5h3.2v-.979h-2.129V8Z" })));
});
